module.exports = __webpack_public_path__ + "static/media/home.5b0e1d30.jpg";